import gsap from "gsap";

export default class GiftCard {
  constructor() {
    this.isOpen = false;
    this.buttons = document.querySelectorAll("[data-js='product-gift-card']");
    this.closeButton = document.querySelector(
      "[data-js='product-gift-card__close']",
    );
    this.container = document.querySelector(
      "[data-js='product-gift-card__container']",
    );
    this.containerElement = document.querySelector(
      "[data-js='product-gift-card__element']",
    );
  }

  init() {
    this.clickOutside();

    this.buttons.forEach((button) => {
      button.addEventListener("click", () => {
        this.isOpen ? this.close() : this.open();
      });
    });

    this.closeButton.addEventListener("click", () => {
      this.close();
    });
  }

  open() {
    this.isOpen = true;
    document.body.style.overflow = "hidden";
    this.container.classList.remove("hidden");

    const tl = gsap.timeline({
      defaults: {
        duration: 0.2,
        ease: "power2.inOut",
      },
    });

    gsap.set([this.container], {
      autoAlpha: 0,
    });

    gsap.set(this.containerElement, {
      xPercent: 100,
    });

    tl.to(this.container, {
      autoAlpha: 1,
      display: "flex",
    });

    tl.to(this.containerElement, {
      xPercent: 0,
    });
  }

  close() {
    this.isOpen = false;

    const tl = gsap.timeline({
      defaults: {
        duration: 0.2,
        ease: "power2.inOut",
      },
    });

    tl.to(this.containerElement, {
      xPercent: 100,
    });

    tl.to(this.container, {
      autoAlpha: 0,
      onComplete: () => {
        this.container.classList.add("hidden");
        document.body.style.overflow = "auto";
      },
    });
  }

  clickOutside() {
    document.addEventListener("click", (event) => {
      if (
        this.isOpen &&
        !this.containerElement.contains(event.target) &&
        !Array.from(this.buttons).some((button) =>
          button.contains(event.target),
        )
      ) {
        this.close();
      }
    });
  }
}
